import { render, staticRenderFns } from "./OperaGoodsCategoryEditWindow.vue?vue&type=template&id=9ae9d01a&"
import script from "./OperaGoodsCategoryEditWindow.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsCategoryEditWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports